export * from './inject'
export * from './provider'



// WEBPACK FOOTER //
// ./src/modules/di/index.ts